import React, { useMemo } from "react";
import { PICK_TYPES } from "src/common-services";
import Dropdown from "../Dropdown";
import ButtonGroup, { ButtonGroupItem } from "../ButtonGroup";
import styles from "./style.scss";
import Tooltip from "src/components/Tooltip";
import Spacer from "../Spacer";
import { WebSportItem } from "src/constants";

interface GameLinesNavProps {
  setLineType(lineType: string): void;
  setStateIndex(stateIndex: number): void;
  selectedLineType: string;
  selectedStateIndex: number;
  currentSportObj: WebSportItem | null;
  size: any;
}

const DEFAULT_LINE_TYPES: ButtonGroupItem[] = [
  { name: "Combined", key: "combined" },
  { key: "spread", name: "Spread" },
  { key: "moneyline", name: "Moneyline" },
  { key: "total", name: "Total" },
  { key: "1Hspread", name: "1H Spread" },
  { key: "1Hmoneyline", name: "1H Moneyline" },
  { key: "1Htotal", name: "1H Total" },
  { key: "2Hspread", name: "2H Spread" },
  { key: "2Hmoneyline", name: "2H Moneyline" },
];

const GameLineNav = ({ currentSportObj, selectedLineType, setLineType, size }: GameLinesNavProps) => {
  const { selectedTypeIndex, lineTypes } = useMemo(() => {
    const types = [];
    currentSportObj?.pickTypes.forEach((pick: string) => {
      types.push({
        key: PICK_TYPES[pick].filterKey,
        name: PICK_TYPES[pick].shortName,
      });
    });

    if (!["NHL", "MLB"].includes(currentSportObj?.key ?? "")) {
      types.unshift({
        name: "Combined",
        key: "combined",
      });
    }

    const index = Math.max(
      0,
      types.findIndex((c) => c.key === selectedLineType)
    );

    return { selectedTypeIndex: index, lineTypes: types };
  }, [currentSportObj?.key, selectedLineType]);

  const favLineType = currentSportObj?.favoriteLine ?? "moneyline";

  return (
    <div className={`nav-header-con ${size}`}>
      <div className="line-text">
        Lines
        <Spacer size={5} />
        <Tooltip title="Lines">
          <p className="popover-text">View the odds for each matchup per sportsbook to find the best opportunities.</p>
          <p className="popover-text">Line are updated within every 5 minutes.</p>
          <p className="popover-text">If they look like have not updated, refresh the page.</p>
        </Tooltip>
      </div>
      {/* On big screens we have all options as a button group */}
      <ButtonGroup
        className={`button-group ${size}`}
        onSelectItem={(item) => setLineType(item.key ?? favLineType)}
        selectedIndex={selectedTypeIndex}
        items={currentSportObj ? lineTypes : DEFAULT_LINE_TYPES}
      />
      {/* On medium screens we have all options as a drop down */}
      <Dropdown
        className={`line-dropdown ${size}`}
        onSelectItem={(item) => setLineType(item.key ?? favLineType)}
        selectedIndex={selectedTypeIndex}
        items={currentSportObj ? lineTypes : DEFAULT_LINE_TYPES}
      />
      {/* On small screens and under we do not have combined as an option and we have a dropdown */}
      <Dropdown
        className={`mobile-line-dropdown ${size}`}
        onSelectItem={(item) => setLineType(item?.key ?? favLineType)}
        selectedIndex={Math.max(0, selectedTypeIndex - 1)}
        items={currentSportObj ? lineTypes.slice(1) : DEFAULT_LINE_TYPES.slice(1)}
      />
      <style jsx global>
        {styles}
      </style>
    </div>
  );
};

export default GameLineNav;
